<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'techLocation',
};
</script>
